export const BREAKPOINT_SWITCH = 'switch';

export default {
  [BREAKPOINT_SWITCH]: '64em',
};
